/**
 * Jubuddy token constants.
 * Game-only (HP bars, currencies, path tiles) are authoritative here.
 * Shared-with-Jubit tokens (mascot colors, section accents) re-imported here
 * as a snapshot — upstream canonical is `jubit-ai-universe/design-system/tokens/colors.json`.
 */

/** Section accent for Jubuddy (reserved color — matches "Terminal" amber from main Jubit). */
export const SECTION_ACCENT = {
  tile: '#F59E0B',
  bgLight: '#FEF3C7',
  bgDark: '#451A03',
} as const;

/** Mascot primary colors — snapshot of main Jubit's palette. */
export const MASCOT_COLORS = {
  jubit: '#FFB0B5',
  cloudra: '#9F7FFF',
  gally: '#74AA9C',
  gemya: '#4285F4',
  grokkie: '#FF9B5A',
  qviki: '#00C9A7',
  lammie: '#0668E1',
  deepo: '#4A90D9',
  mistra: '#FF7F50',
  // ADR-0007 Sprint 12 promotions — matches tailwind.config.ts mascot.* + Studio palette.
  kimora: '#B8D0E8',  // moon silver-blue
  maxie: '#D8B0F0',   // orchid purple
  zhuli: '#F0C8A8',   // warm amber
} as const;

/** Game-only gameplay tokens. Owned by Jubuddy. */
export const GAME_TOKENS = {
  hp: {
    full: '#22C55E',
    mid: '#F59E0B',
    low: '#EF4444',
  },
  shield: '#60A5FA',
  damage: {
    physical: '#F87171',
    elemental: '#FB923C',
    psychic: '#A78BFA',
  },
  currency: {
    coin: '#FBBF24',
    star: '#FACC15',
  },
  tile: {
    path: '#52525B',
    slotEmpty: '#3F3F46',
    slotHover: '#006EAA',
    goal: '#EF4444',
    spawn: '#22D3EE',
  },
} as const;

export type MascotColor = keyof typeof MASCOT_COLORS;
